/**
 * Get currency symbol for a given currency code
 * @param currency - Currency code (e.g., 'USD', 'INR', 'EUR')
 * @returns Currency symbol (e.g., '$', '₹', '€')
 */
export const getCurrencySymbol = (currency: string = 'USD'): string => {
  const currencyMap: { [key: string]: string } = {
    'RS': '₹',
    'INR': '₹',
    'USD': '$',
    'EUR': '€',
    'GBP': '£',
    'JPY': '¥',
    'CNY': '¥',
    'AUD': 'A$',
    'CAD': 'C$',
    'CHF': 'CHF',
    'SGD': 'S$',
    'HKD': 'HK$',
    'NZD': 'NZ$',
    'KRW': '₩',
    'RUB': '₽',
    'BRL': 'R$',
    'ZAR': 'R',
    'MXN': 'MX$',
    'SEK': 'kr',
    'NOK': 'kr',
    'DKK': 'kr',
    'PLN': 'zł',
    'THB': '฿',
    'IDR': 'Rp',
    'MYR': 'RM',
    'PHP': '₱',
    'VND': '₫',
    'AED': 'د.إ',
    'SAR': '﷼',
    'TRY': '₺',
    'ILS': '₪'
  };
  
  return currencyMap[currency.toUpperCase()] || currency;
};
